import authHeader from "./authHeader";

const API_URL = window.REACT_APP_API_URL || window.config.ENDPOINT_ODISEA_API;
const ENDPOINT_API = window.REACT_APP_API_URL || window.config.ENDPOINT_ODISEA_API;
const STORAGE_USER = `user/${window.REACT_APP_WEB_FOLDER || ""}`;

export const registerUser = (username, email, password) => {
  return fetch(`${API_URL}/auth/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({ username, email, password })
  }).then(async response => {
    if (!response.ok) {
      const errorMessage = await response.json();
      throw new Error(errorMessage.message);
    }
    return response.json();
  })
};

export const loginUser = (username, password) => {
  return fetch(`${API_URL}/auth/signin`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ username, password })
  }).then(async response => {  
    if (!response.ok) {
      const errorMessage = await response.json();
      throw new Error(response.status);
    }
    return response.json();
  }).then((data) => {
    if (data.accessToken) {
      localStorage.setItem(STORAGE_USER, JSON.stringify(data));
    }
    return data;
  });
};

export const changePassword = (username, oldPassword, newPassword) => {
  return fetch(`${API_URL}/auth/changePassword`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify({ username, oldPassword, newPassword })
  }).then(async response => {  
    if (!response.ok) {
      const errorMessage = await response.json();
      throw new Error(errorMessage.message);
    }
    return response.json();
  });
};


export const logoutUser = () => {
  localStorage.removeItem(STORAGE_USER);
};

export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem(STORAGE_USER));
};

export const refreshToken = async () => {

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      refreshToken: JSON.parse(localStorage.getItem(STORAGE_USER)).refreshToken,
    }),
  }

  let result = null;  

  await fetch(`${API_URL}/auth/refreshtoken`, requestOptions)
    .then( response => response.text())
    .then( response => {
      response = JSON.parse(response);
      return response;
    })
    .then(async (response) => {
      if (response) {
        const { accessToken, refreshToken } = response;
        const user = JSON.parse(localStorage.getItem(STORAGE_USER));
        const updatedUser = {
          ...user,
          'accessToken': accessToken,
          'refreshToken': refreshToken
        }
        localStorage.removeItem(STORAGE_USER);
        localStorage.setItem(STORAGE_USER, JSON.stringify(updatedUser));
        result = accessToken;
      } else {
        localStorage.removeItem(STORAGE_USER);
        result = null;
      }
  });

  return result;
}

export async function getUsersList (callback, id) {
  const requestOptions = {
    method: 'GET',
    credentials: 'same-origin',
    //origin: true,
    redirect: 'follow',
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_API}/users`, requestOptions)
    .then( response => response.text())
    .then( response => {

      response = JSON.parse(response);
      return response;
    })
    .then( (r) => callback(r) )
    .catch(error => console.log('error', error));
};

export async function editUsers (callback, id, body) {
  const requestOptions = {
    method: 'PUT',
    credentials: 'same-origin',
    //origin: true,
    redirect: 'follow',
    body: JSON.stringify(body),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_API}/users/${id}`, requestOptions)
    .then(async response => {
      if (!(response.ok)) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message);
      }

      return response
    })
    .then( response => response.text())
    .then( response => {
      response = JSON.parse(response);
      return response;
    })
    .then( (r) => callback(r) )
};


export async function deleteUsers (callback, id) {
  const requestOptions = {
    method: 'DELETE',
    credentials: 'same-origin',
    //origin: true,
    redirect: 'follow',
  };

  requestOptions['headers'] = { ...requestOptions['headers'], ...authHeader() };

  await fetch(`${ENDPOINT_API}/users/${id}`, requestOptions)
    .then(async response => {
      if (!(response.ok)) {
        const errorMessage = await response.json();
        throw new Error(errorMessage.message);
      }

      return response
    })
    .then( response => response.text())
    .then( response => {
      response = JSON.parse(response);
      return response;
    })
    .then( (r) => callback(r) )
};
